import { useLocales } from '@sevenrooms/locales'
import { DateOnly } from '@sevenrooms/timepiece'
import { Button } from '@sevenrooms/ui-kit/form'
import { Text } from '@sevenrooms/ui-kit/typography'
import { reservationWidgetMessages } from '../../reservationWidgetMessages'

interface TimeFilterButtonProps {
  date: string
  onClick?: () => void
}

export function TimeFilterButton({ date, onClick }: TimeFilterButtonProps) {
  const { formatMessage } = useLocales()
  return (
    <Button data-test="sr-show-x-more-times" type="button" variant="tertiary" noPadding onClick={onClick}>
      <Text textStyle="h3" color="primaryFont" textDecoration="underline">
        {formatMessage(reservationWidgetMessages.resWidgetShowAllTimes, {
          date: DateOnly.from(date).formatSMonthNDaySWeek(),
        })}
      </Text>
    </Button>
  )
}
